define('views/components/metrik/metrik_license',['require','backbone','text!templates/components/metrik/metrik_license.html','context/basket','models/basket_product'],function(require){
    var Backbone = require('backbone');

    var temp = require("text!templates/components/metrik/metrik_license.html");

    var Basket = require('context/basket');
    var BasketProductModel = require('models/basket_product');


    return Backbone.Marionette.ItemView.extend({
        template: _.template(temp),
        className: "metrik_license",

        ui: function(){
            return{
                extendButom: "#extend-button"
            };
        },

        events: {
            'click @ui.extendButom': 'extendButtonClicked'

        },

        extendButtonClicked: function (){
            // Clear basket first
            App.context.basket = new Basket();

            // Add product to basket
            var basketProduct = new BasketProductModel({
                product: this.model.get('product'),
                count: 1,
                license: this.model.get('id')
            });
            App.context.basket.get('products').push(basketProduct.attributes);

            // Redirect to checkout page
            App.context.redirect('/checkout');
        }
    });
});
